// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"ca2fec7e8d92181dde29","678":"930b7eba10c018b60dfc","883":"84b6f7c6fdde4114455b"}[chunkId] + ".js";
};